import React from "react";
import { connect } from "react-redux";
import { NextStepButton, Logo } from "components";

const Tab7 = props => {
  const domainStrings = props.domain.Strings;
  const { refNumber } = props;

  return (
    <div className="form_steps">
      <div className="form_steps--inner flex">
        <div className="full_column">
          <Logo />

          <div>
            <h2 className="link_checkbox_container--title">{props.companyPredictedTurnover >= 10000000 ? domainStrings.tab7TitleHighTurnover : domainStrings.tab7Title}</h2>
            <div className="checkbox_container--content">
              <p>{props.companyPredictedTurnover >= 10000000 ? domainStrings.tab7SubTitleHighTurnover : domainStrings.tab7SubTitle}</p>
            </div>
            <div style={{ marginTop: 20 }} className="checkbox_container--content">
              <p>
                {domainStrings.tab7RefNumber} <b>{refNumber}</b>
              </p>
            </div>
            <NextStepButton isLink onShow text={domainStrings.tab7NextBtn} link={domainStrings.tab7NextBtnLink} />
          </div>
        </div>
      </div>
    </div>
  );
};
const mapStateToProps = state => {
  return {
    ...state.app
  };
};
export default connect(
  mapStateToProps,
  null
)(Tab7);
